import linkedInIcon from "../assets/linkedin.svg";

const About = () => {
  const txt = `a passionate and skilled full-stack web developer with a strong background in creating dynamic and user-friendly applications. 
    With a blend of technical expertise and creative problem-solving,
    I strive to build innovative digital solutions to provide an exceptional user experience.`;

  return (
    <div className="p-4">
      <div className="text-5xl md:text-7xl p-4">
        <div className="flex flex-col md:flex-row">
          <div className="font-black text-amber-300 pr-4">Hola!</div>
          <div className="font-black text-amber-300">I'm </div>
        </div>
        <div className="py-4">
          <div className="font-black text-orange-500">Shyam Kumar</div>
          <div className="flex">
            <div className="sm:flex font-black text-orange-500">
              <div>Karuturi</div>
              <div className="flex">
                {" "}
                <div className="flex">👋🏻</div>
                <a
                  href="https://www.linkedin.com/in/shyam-kumar-karuturi-0512931b0/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ml-2 self-end"
                >
                  <img
                    src={linkedInIcon}
                    alt="LinkedIn"
                    style={{ width: "32px", height: "32px" }}
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <p className=" text-blue-300 p-4">
        <span className="text-base md:text-4xl font-bold">{txt}</span>
      </p>
    </div>
  );
};

export default About;
